var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "tab-section",
    style: _vm.style
  }, [_c('ContainerVue', [_c('div', [_c('Tabs', {
    class: _vm.mobile.showMobile && 'sm-md:hidden',
    attrs: {
      "section-header": _vm.header
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('Tab', {
      key: tab._key,
      attrs: {
        "title": tab.title
      }
    }, _vm._l(tab.content, function (content) {
      return _c('div', {
        key: content._key
      }, [content._type === 'grid' ? _c('grid', _vm._b({}, 'grid', content, false)) : _vm._e(), _vm._v(" "), content._type === 'table' ? _c('sanity-table', _vm._b({}, 'sanity-table', content, false)) : _vm._e()], 1);
    }), 0);
  }), 1), _vm._v(" "), _c('Tabs', {
    class: _vm.mobile.showMobile ? 'hidden sm-md:block' : 'hidden',
    attrs: {
      "section-header": _vm.header
    }
  }, _vm._l(_vm.mobile.tabs, function (tab) {
    return _c('Tab', {
      key: tab._key,
      attrs: {
        "title": tab.title
      }
    }, _vm._l(tab.content, function (content) {
      return _c('div', {
        key: content._key
      }, [content._type === 'grid' ? _c('grid', _vm._b({}, 'grid', content, false)) : _vm._e(), _vm._v(" "), content._type === 'table' ? _c('sanity-table', _vm._b({}, 'sanity-table', content, false)) : _vm._e()], 1);
    }), 0);
  }), 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };